import { getDefaultLanguage } from '@rbilabs/intl';
import dlv from 'dlv';

import { IStaticPageRoute } from 'remote/queries/static-page';
import { FALLBACK_LANGUAGE } from 'utils/constants';
import { brand } from 'utils/environment';

import { localeRoutes } from './generated/locale-routes';

export { localeRoutes } from './generated/locale-routes';

export const getStaticPagesLocalizedRouteForPath = (
  path: string,
  staticRoutes: IStaticPageRoute[],
  language: string
) => {
  if (!staticRoutes || !Array.isArray(staticRoutes)) {
    return null;
  }

  let localizedRelativePath = null;

  staticRoutes.forEach((route: any) => {
    if (dlv(route, 'path.current') === path) {
      const localizedPathWithFallback =
        dlv(route, `localePath.${language}.current`) ||
        dlv(route, `redirectUrl.locale`) ||
        route.path.current;
      localizedRelativePath = `/${localizedPathWithFallback}`;
    }
  });

  return localizedRelativePath;
};

export const getInCodeLocalizedRouteForPath = (
  relativePath: string,
  language: string,
  region: string
) => {
  const defaultLanguageLocaleRoutes =
    localeRoutes[getDefaultLanguage(brand(), region) ?? FALLBACK_LANGUAGE];

  const defaultLanguageRouteKey = Object.keys(defaultLanguageLocaleRoutes).find(
    key => defaultLanguageLocaleRoutes[key] === relativePath
  );

  if (defaultLanguageRouteKey) {
    return (
      dlv(localeRoutes, `${language}.${defaultLanguageRouteKey}`) ||
      defaultLanguageLocaleRoutes[defaultLanguageRouteKey]
    );
  }

  return null;
};
